import { Candidate, WorkAuthorization } from '~/services/types/candidate';
import { User } from '~/services/types/identity';

interface ProfileState {
    candidate: Candidate | null;
    user: User | null;
    workAuthorizations: WorkAuthorization[] | null;
}

export default {
    namespaced: true,
    state: {
        candidate: null,
        user: null,
        workAuthorizations: null,
    } as ProfileState,
    getters: {
        getCandidate: (state: ProfileState) => () => state.candidate,
        getUser: (state: ProfileState) => () => state.user,
        getWorkAuthorizations: (state: ProfileState) => () => state.workAuthorizations,
    },
    mutations: {
        setCandidate(state: ProfileState, candidate: Candidate | null) {
            state.candidate = candidate;
        },
        setUser(state: ProfileState, user: User | null) {
            state.user = user;
        },
        setWorkAuthorizations(state: ProfileState, workAuthorizations: WorkAuthorization[] | null) {
            state.workAuthorizations = workAuthorizations;
        },
        clear() {
            return {
                candidate: null,
                user: null,
                workAuthorizations: null,
            };
        },
    },
};
